import { isAvailableFeatureSelector } from 'features/billing'

export const isUserProfilesFeatureAvailableSelector = (state) => isAvailableFeatureSelector(state, { featureKey: 'user_profiles' })
